import { useMemo } from 'react';
import classNames from 'classnames';
import { Flex, Modal } from 'antd';
import TabContent from '../components/TabContent';
import { TabSelectBtn } from '../../../common/TabSelectBtn';
import { VendorPopupTab } from '../VendorPopupTab.enum';

import styles from './VendorPopup-desktop.module.css';

interface VendorPopupDesktop {
  isOpened: boolean;
  vendorId: number;
  title: string;
  tab: VendorPopupTab;
  onTabChange: (tab: VendorPopupTab) => void;
  onClose: () => void;
}

const VendorPopupDesktop: React.FC<VendorPopupDesktop> = ({
  isOpened,
  onClose,
  title,
  vendorId,
  onTabChange,
  tab,
}) => {
  const tabSwitch = useMemo(() => {
    return (
      <Flex
        justify="stretch"
        gap="small"
        className={classNames('trojan-glassphormism-box', styles.tabSelectBox)}
      >
        <TabSelectBtn
          active={tab === VendorPopupTab.VendorDetails}
          value={VendorPopupTab.VendorDetails}
          onClick={() => onTabChange(VendorPopupTab.VendorDetails)}
        >
          Vendor Details
        </TabSelectBtn>
        <TabSelectBtn
          value={VendorPopupTab.Quotation}
          active={tab === VendorPopupTab.Quotation}
          onClick={() => onTabChange(VendorPopupTab.Quotation)}
        >
          Quotation
        </TabSelectBtn>
        <TabSelectBtn
          value={VendorPopupTab.Remarks}
          active={tab === VendorPopupTab.Remarks}
          onClick={() => onTabChange(VendorPopupTab.Remarks)}
        >
          Remarks
        </TabSelectBtn>
      </Flex>
    );
  }, [tab, onTabChange]);

  return (
    <Modal open={isOpened} footer={null} title={title} onCancel={onClose}>
      {tabSwitch}
      <TabContent selectedTab={tab} vendorId={vendorId} />
    </Modal>
  );
};

export default VendorPopupDesktop;
